export const cameraConfig = {
  initial: { x: 400, y: 768, distance: 950, yaw: 0.45, tilt: 0.83 },
  fieldOfView: 43,
  near: 2,
  far: 18000,
  easing: 12,
  panReferenceDistance: 950,
  minDistance: 230,
  maxDistance: 5500,
  dragRotation: 0.006,
  wheelZoom: 0.001,
  keyboardRotation: 0.0015,
  panMaxDeltaMs: 64,
  panSpeed: 0.6,
  doubleClickMs: 350,
};
